import { CODE_BLOCK_REGEX, PARSE_CODE_BLOCK_REGEX } from 'chatspot-core/messages/code/CodeRegex';
import { useMemo } from 'react';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/transitional/components/View';
import CodeBlock from '../../components/text/CodeBlock';
import Markdown from '../../components/text/Markdown';
import InlineCitationSectionFormatter from './InlineCitationSectionFormatter';
// @ts-expect-error - html-react-parser is a vendored JS file without types
import parse, { Element } from '../../vendor/html-react-parser';
import { jsx as _jsx } from "react/jsx-runtime";
function hasCitations(section) {
  return '__typename' in section && section.__typename === 'com.hubspot.chatspot.message.schemas.sections.HtmlTextResponseSection';
}
const MessageWrapper = styled.div.withConfig({
  displayName: "HtmlSectionFormatter__MessageWrapper"
})(["width:100%;"]);
const HtmlSectionFormatter = ({
  section,
  callbacks
}) => {
  const {
    text = ''
  } = section;
  const inlineCitations = hasCitations(section) ? section.citations : null;
  const processedText = useMemo(() => {
    if (!inlineCitations) return text;
    return text.replace(/\[ai-section:([^\]]+)\]/g, (_match, id) => {
      if (inlineCitations[id]) {
        return `<span data-citation-id="${id}"></span>`;
      }
      return _match;
    });
  }, [text, inlineCitations]);
  const shouldRenderCitations = inlineCitations && processedText.includes('data-citation-id');
  const messageBlocks = useMemo(() => {
    const textBlocks = processedText.split(CODE_BLOCK_REGEX);
    return textBlocks.map((textBlock, index) => {
      const parsedCodeBlock = textBlock.match(PARSE_CODE_BLOCK_REGEX);
      if (parsedCodeBlock) {
        const [__fullTextBlock, language, code] = parsedCodeBlock;
        return /*#__PURE__*/_jsx(CodeBlock, {
          code: code,
          language: language
        }, index);
      }
      if (shouldRenderCitations) {
        const parsedContent = parse(textBlock, {
          replace: domNode => {
            var _domNode$attribs;
            if (domNode instanceof Element && domNode.name === 'span' && (_domNode$attribs = domNode.attribs) !== null && _domNode$attribs !== void 0 && _domNode$attribs['data-citation-id']) {
              const citationId = domNode.attribs['data-citation-id'];
              const citation = inlineCitations[citationId];
              if (citation) {
                return /*#__PURE__*/_jsx(View, {
                  display: "inline-block",
                  marginInlineStart: "100",
                  children: /*#__PURE__*/_jsx(InlineCitationSectionFormatter, {
                    section: citation,
                    callbacks: callbacks
                  })
                });
              }
            }
          }
        });
        return /*#__PURE__*/_jsx("span", {
          children: parsedContent
        }, index);
      }
      return /*#__PURE__*/_jsx(Markdown, {
        html: textBlock
      }, index);
    });
  }, [processedText, shouldRenderCitations, inlineCitations, callbacks]);
  return /*#__PURE__*/_jsx(MessageWrapper, {
    children: messageBlocks
  });
};
export default HtmlSectionFormatter;